import { Redirect_1 } from "@sveltejs/kit";
import {
  classRegistry,
  ObjectEvents,
  TClassProperties,
  TOptions,
  Textbox,
  SerializedTextboxProps,
} from "fabric";

interface UniqueCustomProps {
  name: string;
  maxWidth: number | null;
  maxHeight: number | null;
}

export interface SerializedCustomProps
  extends SerializedTextboxProps,
    UniqueCustomProps {}

export interface CustomProps
  extends SerializedTextboxProps,
    UniqueCustomProps {}

export default class TextBoxPlus<
  Props extends TOptions<CustomProps> = Partial<CustomProps>,
  SProps extends SerializedCustomProps = SerializedCustomProps,
  EventSpec extends ObjectEvents = ObjectEvents,
> extends Textbox<Props, SProps, EventSpec> {
  static type = "textbox";
  declare maxHeight: number | null;
  declare maxWidth: number | null;
  declare name: string;

  initDimensions() {
    super.initDimensions();
    this.fitToBox();
  }

  fitToBox() {
    const breakWidth =
      this.maxWidth && this.getMinWidth() > this.maxWidth && this.fontSize > 1;
    const breakHeight =
      this.maxHeight &&
      this.getScaledHeight() > this.maxHeight &&
      this.fontSize > 1;

    if (breakHeight || breakWidth) {
      if (breakWidth) {
        this.width = this.maxWidth;
      }
      this.fontSize = this.fontSize - 1;
      this.initDimensions();
    }
  }

  toObject<
    T extends Omit<Props & TClassProperties<this>, keyof SProps>,
    K extends keyof T = never,
  >(propertiesToInclude: K[] = []): Pick<T, K> & SProps {
    return super.toObject([
      ...propertiesToInclude,
      "name",
      "maxHeight",
      "maxWidth",
    ]);
  }
}
// to make possible restoring from serialization
classRegistry.setClass(TextBoxPlus, "textbox");
// to make PathPlus connected to svg Path element
classRegistry.setSVGClass(TextBoxPlus, "textbox");
